////// !TODO this is a duplicate from omni-server-utils //////

/* eslint-disable no-useless-catch */
import { inBrowser } from "@omnichannel/ace-b2b-elements"
const nodeUtil = require("util")
const { sign, verify, decode } = require("jsonwebtoken")

/**
 * Decodes JWT Token
 * @param {String} token JWT Token
 * @return {Object} Decoded JWT Token
 */
// this can be used on client
const decodeToken = token => {
  try {
    return decode(token)
  } catch (err) {
    throw err
  }
}

/**
 * Decodes but checks if secret key is the same as the server
 * @param {String} token JWT Token
 * @param {String} secret Secret Key
 * @return {Object} Decoded JWT Token
 */
// same as decode, but uses secret key for security
const verifyToken = async (token, secret) => {
  try {
    // authentication
    const jwtVerify = nodeUtil.promisify(verify)
    const decoded = await jwtVerify(token, secret)
    return decoded
  } catch (err) {
    throw err
  }
}

/**
 * Generates JWT Token
 * @param {Object} data Data for JWT Token
 * @param {String} secret Secret Key for verification
 * @param {Number} expiresIn JWT Life
 * @return {String} JWT Token
 */
const generateToken = async (data, secret, expiresIn = null) => {
  const jSign = nodeUtil.promisify(sign)

  let opts = {}
  if (expiresIn) {
    opts = {
      expiresIn,
    }
  }

  try {
    const token = await jSign(data, secret, opts)
    return token
  } catch (err) {
    throw err
  }
}

/**
 * Gets bearer token
 * @param {*} req Request Object
 * @param {*} tokenType Type of token
 * @return {String} Bearer Token
 */
const getBearerToken = (req, tokenType = "authorization") => {
  try {
    const reqHeaders = req.headers
    let token = ""
    if (reqHeaders && reqHeaders[tokenType]) {
      const parts = reqHeaders[tokenType].split(" ")
      if (parts.length === 2 && parts[0] === "Bearer") {
        token = parts[1]
      }
    }
    return token
  } catch (err) {
    throw err
  }
}

/**
 * Filters specific fields from user object
 * @param {Object} user User Object
 * @return {Object} Filtered User Object
 */
// MODIFIED for customers table
const filterUserFields = user => ({
  _id: user._id,
  userid: user.userid,
  firstName: user.firstName,
  lastName: user.lastName,
  email: user.email,
  emailStatus: user?.emailStatus,
  socialFlag: user?.socialFlag,
})

/**
 * Parse header for tokens
 * @param {Object} req Request Object
 * @return {Object} Access token and refresh token
 */
const getTokens = req => {
  /* This will parse the headers
   * { "Authorization": "Bearer abc123",
   *   "Refresh-Token": "Bearer xyz123" }
   */
  // TODO: verify this
  const accessToken = getBearerToken(req)
  const refreshToken = getBearerToken(req, "refresh-token")

  return {
    accessToken,
    refreshToken,
  }
}

/**
 *
 * @typedef {Object} TokenParam
 * @property {Object} user User Object
 * @property {String} accessSecret Access token secret key
 * @property {Number} accessLife Access token lifetime
 * @property {String} refreshSecret Refresh token secret key
 * @property {Number} refreshLife Refresh token lifetime
 */

/**
 *
 * @param {TokenParam} param0 Token {@link TokenParam} objects
 * @return {Object} Access token and refresh token
 */
const createTokens = async ({
  userInfo,
  accessSecret,
  accessLife,
  refreshSecret,
  refreshLife,
}) => {
  const filteredUser = filterUserFields(userInfo)

  const { _id, count } = userInfo
  const sub = _id

  const refreshToken = await generateToken(
    { userInfo: filteredUser, user: sub, sub, count },
    refreshSecret,
    refreshLife
  )

  const accessToken = await generateToken(
    { userInfo: filteredUser, user: sub, sub },
    accessSecret,
    accessLife
  )

  return { refreshToken, accessToken }
}

/**
 *
 * @typedef {Object} CustomerToken
 * @property {Object} customer Customer Object
 * @property {String} accessSecret Access token secret key
 */

/**
 * Generates customer token for shopsm
 * @param {CustomerToken} param0 Customer {@link CustomerToken} object
 * @return {String} Customer access token
 */
const createCustomerToken = async ({ customer, accessSecret }) => {
  const { _id } = customer
  const accessToken = await generateToken({ sub: _id }, accessSecret)
  return accessToken
}

/**
 * Generates refresh token for refresh
 * @param {TokenParam} param0 Token {@link TokenParam} objects
 * @return {Object} Access token and refresh token
 */
const refreshTokens = async ({
  token,
  refreshSecret,
  refreshLife,
  accessSecret,
  accessLife,
}) => {
  const { user, userId, count } = await decodeToken(token, refreshSecret)

  const filteredUser = filterUserFields(user)

  const accessToken = await generateToken(
    { userId, user: filteredUser },
    accessSecret,
    accessLife
  )

  const refreshToken = await generateToken(
    { userId, count, user: filteredUser },
    refreshSecret,
    refreshLife
  )

  return { refreshToken, accessToken }
}

/**
 * Gets token lifetime
 * @param {String} token
 * @return {Number} token lifetime in seconds
 */
const getTokenRemainingTime = token => {
  const { exp } = decodeToken(token)
  const currentTime = new Date().getTime() / 1000
  const remainingTime = exp - Math.floor(currentTime)
  return remainingTime
}

const getAccessToken = () => inBrowser && localStorage.getItem("access-token")

/**
 * Clears local storage
 */
const clearTokens = () => {
  inBrowser && localStorage.removeItem("access-token")
}

export {
  verifyToken,
  decodeToken,
  generateToken,
  getBearerToken,
  getTokens,
  createTokens,
  refreshTokens,
  createCustomerToken,
  getTokenRemainingTime,
  getAccessToken,
  clearTokens,
}
